import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardPageComponent } from './dashboard-page/dashboard-page.component';

export const dashboardRoutes: Routes = [
    {
        path: '',
        component: DashboardPageComponent,
    },
];

@NgModule({
    imports: [
        RouterModule.forChild(dashboardRoutes),
    ],
    exports: [
        RouterModule,
    ],
})
export class DashboardRoutingModule {
}
